import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { LoginContext } from "../context/LoginContext";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";

const Upload = (props) => {
  const [showUpload, setShowUpload] = useState(false);

  const [showResult, setShowResult] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [isVideo, setIsVideo] = useState(false);

  const [showDeleteResult, setShowDeleteResult] = useState(false);

  const [image, setImage] = useState({ preview: "", raw: "" });

  const [result, setResult] = useState("");

  const [deleteResult, setDeleteResult] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const login = useContext(LoginContext);

  const [theme, switchTheme] = useTheme();

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const remove = () => {
    setImage({
      preview: "",
      raw: "",
    });
  };

  const deleteBackground = () => {
    const formData = new FormData();
    formData.append("delete_background", 1);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDeleteResult(data.data);
        setShowDelete(false);
        setShowDeleteResult(true);
      })
      .catch((e) => {
        console.log(e);
        setShowDelete(false);
        setShowDeleteResult(true);
        setDeleteResult("اشکال در برقراری ارتباط با سرور");
      });
  };

  const upload = () => {
    setIsLoading(true);
    const formData = new FormData();
    if (isVideo) {
      formData.append("upload_video", 1);
      formData.append("file", image.raw);
      formData.append("vitrinCode", props.vitrinCode);
      formData.append("barcode", props.barcode);
    } else {
      if (props.type === "productImage") {
        formData.append("upload_image", 1);
        formData.append("file", image.raw);
        formData.append("vitrinCode", props.vitrinCode);
        formData.append("barcode", props.barcode);
      } else if (props.type === "background") {
        formData.append("background", 1);
        formData.append("file", image.raw);
        formData.append("vitrinCode", props.vitrinCode);
      }
    }
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setResult(data.data);
        setShowUpload(false);
        setShowResult(true);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setShowUpload(false);
        setShowResult(true);
        setIsLoading(false);
        setResult("اشکال در برقراری ارتباط با سرور");
      });
  };

  if (login.loginState) {
    if (login.userInfo.isModir) {
      return (
        <div>
          {props.type === "productImage" &&
          props.vitrinCode.toString() === props.vitrinImg ? (
            <div className="d-flex justify-content-center mt-3">
              <button
                className="btn btn-info"
                onClick={() => {
                  setShowUpload(true);
                }}
              >
                افزودن تصویر
              </button>
            </div>
          ) : null}

          {props.type === "background" ? (
            <Nav.Link
              onClick={() => {
                setShowUpload(true);
              }}
              href="#"
              className={theme === "light" ? "text-dark" : "text-light"}
            >
              پس زمینه
            </Nav.Link>
          ) : null}

          <Modal
            show={showUpload}
            onHide={() => setShowUpload(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              className={
                theme === "light"
                  ? "bg-light text-dark rtl justify-content-center"
                  : "rtl justify-content-center bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              {!isLoading ? (
                <div className="d-flex justify-content-center mt-3">
                  <label htmlFor="upload-button">
                    {image.preview ? (
                      <div>
                        <img
                          src={image.preview}
                          alt="upload"
                          width="300"
                          height="300"
                        />
                        <div className="d-flex justify-content-center mt-3">
                          <button className="btn btn-danger" onClick={remove}>
                            حذف
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          border: "1px black solid",
                          borderRadius: "5px",
                          padding: "3px",
                        }}
                      >
                        <FontAwesomeIcon icon={faUpload} />
                        آپلود تصویر
                      </div>
                    )}
                  </label>
                  <input
                    type="file"
                    id="upload-button"
                    style={{ display: "none" }}
                    onChange={handleChange}
                  />
                </div>
              ) : (
                <div className="row justify-content-center m-5 p-5">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <button
                className="btn btn-dark"
                onClick={() => setShowUpload(false)}
              >
                بستن
              </button>
              {props.type === "background" ? (
                <button
                  className="btn btn-danger"
                  onClick={() => setShowDelete(true)}
                >
                  حذف تصویر پس زمینه
                </button>
              ) : null}
              <button className="btn btn-success" onClick={upload}>
                آپلود
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showResult}
            onHide={() => setShowResult(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              className={
                theme === "light"
                  ? "bg-light text-dark rtl justify-content-center"
                  : "rtl justify-content-center bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <div>{result}</div>
            </Modal.Body>
            <Modal.Footer
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <button
                className="btn btn-dark"
                onClick={() => setShowResult(false)}
              >
                بستن
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDelete}
            onHide={() => setShowDelete(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              className={
                theme === "light"
                  ? "bg-light text-dark rtl justify-content-center"
                  : "rtl justify-content-center bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <div>آیا از حذف تصویر پس زمینه اطمینان دارید؟</div>
            </Modal.Body>
            <Modal.Footer
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <button
                className="btn btn-danger"
                onClick={() => setShowDelete(false)}
              >
                خیر
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  deleteBackground();
                }}
              >
                بله
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showDeleteResult}
            onHide={() => setShowResult(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
          >
            <Modal.Header
              className={
                theme === "light"
                  ? "bg-light text-dark rtl justify-content-center"
                  : "rtl justify-content-center bg-dark text-light"
              }
            ></Modal.Header>
            <Modal.Body
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <div>{deleteResult}</div>
            </Modal.Body>
            <Modal.Footer
              className={
                theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
              }
            >
              <button
                className="btn btn-dark"
                onClick={() => setShowDeleteResult(false)}
              >
                بستن
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return <div className="col-6"></div>;
    }
  } else {
    return null;
  }
};

export default Upload;
